import { Icon } from '@iconify/react';
import warningFilled from '@iconify/icons-fluent/text-bullet-list-square-warning-24-filled';
// material
import { alpha, styled } from '@mui/material/styles';
import { Card, Typography } from '@mui/material';
// utils
import { fShortenNumber } from '../../../utils/formatNumber';

// ----------------------------------------------------------------------

const RootStyle = styled(Card)(({ theme }) => ({
  boxShadow: 'none',
  textAlign: 'center',
  padding: theme.spacing(5, 0),
  color: theme.palette.error.darker,
  backgroundColor: theme.palette.error.lighter
}));

const RootStyle1 = styled(Card)(({ theme }) => ({
  height : 190,
  boxShadow: 'none',
  textAlign: 'center',
  padding: theme.spacing(5, 0),
  color: '#2D99FF',
  backgroundColor: '#d2e9ff'
}));

const IconWrapperStyle = styled('div')(({ theme }) => ({
  margin: 'auto',
  display: 'flex',
  borderRadius: '50%',
  alignItems: 'center',
  width: theme.spacing(8),
  height: theme.spacing(8),
  justifyContent: 'center',
  marginBottom: theme.spacing(3),
  color: theme.palette.error.dark,
  backgroundImage: `linear-gradient(135deg, ${alpha(theme.palette.error.dark, 0)} 0%, ${alpha(
    theme.palette.error.dark,
    0.24
  )} 100%)`
}));

// ----------------------------------------------------------------------

const TOTAL = 234;

export default function AppEvent(props) {
  
  if(props.img !== undefined)
    return (
      <RootStyle >
        <IconWrapperStyle >
          <img src={props.img} width={40} height={40} alt="description"/>
        </IconWrapperStyle>
        <Typography variant="h3">
          {props.TOTAL}
          {props.unit}
        </Typography>
        <Typography variant="h4" sx={{ opacity: 0.72 }}>
          {props.title}
        </Typography>
      </RootStyle>
    );
  if(props.icon !== undefined)
    return (
      <RootStyle >
        <IconWrapperStyle >
          <Icon icon={props.icon} width={25} height={25} />
        </IconWrapperStyle>
        <Typography variant="h3">
          {props.TOTAL}
          {props.unit}
        </Typography>
        <Typography variant="h4" sx={{ opacity: 0.72 }}>
          {props.title}
        </Typography>
      </RootStyle>
    );
    
  return (
    <RootStyle1 >
      <Typography variant="h4" sx={{ opacity: 0.72 }} >
        {props.title} 
      </Typography>
      <Typography variant="h4" sx={{ opacity: 0.72 }} mb={1}>
        {props.subtitle} 
      </Typography>
      <Typography variant="h3">
        {props.TOTAL} {props.unit}        
      </Typography>
    </RootStyle1>
  );
}
